import React, { useState } from 'react';
import { Card } from 'antd';
import '../CaseCategory/CaseCategory.css';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { AiOutlineDashboard } from 'react-icons/ai';
import axios from 'axios';

const CaseCategory = () => {
  const baseurl =
    'http://admin.defconinnovations.com/advocateapi/case-categories/';
  const token = 'c404c955a08ca1779628c914e7692927074af875';
  const [name, setName] = useState();
  const handleChange = e => {
    setName({ ...name, [e.target.name]: e.target.value });
  };
  const handleClick = async () => {
    try {
      const response = await axios.post(baseurl, name, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${token}`,
        },
      });

      if (response.status === 201) {
        alert('Case Saved');
      }
    } catch (error) {
      /* console.log(error); */
    }
  };

  return (
    <div className="mb-2 mt-2 p-4">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="d-flex align-items-center ">
          <h3>Case Category</h3>
          <h6 className="px-2 case-category">Add</h6>
        </div>
        <div className="d-flex gap-2 ">
          <h6 className="d-flex align-items-center">
            <AiOutlineDashboard />
            Dashboard
          </h6>
          <h6 className="d-flex align-items-center">
            <MdKeyboardArrowRight />
            Case Category
          </h6>
          <h6 className="d-flex align-items-center">
            <MdKeyboardArrowRight />
            Add
          </h6>
        </div>
      </div>
      <Card
        className="w-100 mt-2 p-1"
        title="Add"
        variant="borderless"
        style={{
          width: 300,
        }}
      >
        <h4 className="mb-5">Category Name</h4>
        <form>
          <input
            onChange={handleChange}
            name="name"
            className="w-25 p-2 mb-5 rounded border border-dark p-2"
            type="text"
            placeholder="Enter Your Name"
          />
        </form>

        <div className="border-top ">
          <button
            onClick={handleClick}
            className="border border-none p-2 bg-primary text-white mt-2 save-btn"
          >
            Save
          </button>
        </div>
      </Card>
    </div>
  );
};

export default CaseCategory;
